<template>
	<div class="tw-flex tw-items-center tw-gap-3">
		<ChangeStatusMenu
			v-if="orderDetailsStore.order"
			:order="orderDetailsStore.order"
			@done="orderDetailsStore.refetchOrder"
			:title="$unauthorizedMessage('orders.{linked_marketplace_id}.change_status', { linked_marketplace_id: orderDetailsStore.order.linked_marketplace_id })"
			:disabled="$cannot('orders.{linked_marketplace_id}.change_status', { linked_marketplace_id: orderDetailsStore.order.linked_marketplace_id }) || authStore.isSyncDisabled"
		/>
		<AppSkeleton v-else type="button" width="70px" />
		<AppButton
			v-if="
				orderDetailsStore.order?.marketplace?.id === marketplacesEnum.WhatsApp &&
				orderDetailsStore.order.orderStatusValue === OrderStatus.Draft
			"
			:label="$t('orders.send-order-summary')"
			secondary
			variant="gray"
			startIcon="assets/v2/image/icons/send.svg"
			:loading="sendSummaryLoading"
			@click="sendOrderSummary"
		/>
	</div>
</template>

<script setup>
import AppSkeleton from '@/v2/components/skeleton.vue';
import ChangeStatusMenu from '../../../components/change-status-menu.vue';

import { useOrderDetailsStore } from '../../../stores/order-details';
import { ref } from 'vue';
import { marketplacesEnum } from '../../../../../utils/marketplaces';
import { Alert } from '../../../../../plugins/alert';
import { useI18n } from 'vue-i18n';
import { OrderStatus } from '../../../entities/enums';
import { useAuthStore } from '@/v2/store/shared/auth-store';

const orderDetailsStore = useOrderDetailsStore();
const authStore = useAuthStore();
const sendSummaryLoading = ref(false);
const { t } = useI18n();

const sendOrderSummary = async () => {
	sendSummaryLoading.value = true;
	try {
		await orderDetailsStore.order.sendOrderSummaryToWhatsApp();
		Alert.success(t('success-msg'));
	} finally {
		sendSummaryLoading.value = false;
	}
};
</script>

<style lang="scss" scoped></style>
